/* eslint-disable */
export default {
  forward: '착신 전환',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
